import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const UserMenuTitleMobileDefaultBox = styled.div`
    margin: 0;
    line-height: 1;
    ${({theme}) => theme.font.presets.bold};
    font-size: 1.6rem;
    color: ${({theme}) => theme.colors.textLight};
    width: 100%;
    margin-bottom: 0.25rem;
`;

/* 777 */
const UserMenuTitleMobileCasino777Box = styled(UserMenuTitleMobileDefaultBox)`
    ${({theme}) => theme.font.presets.body};
    font-size: 1.8rem;
`;

export const UserMenuTitleMobileBox = styledByTheme(UserMenuTitleMobileDefaultBox).forCasino777(UserMenuTitleMobileCasino777Box).apply();
